export const classes = {
    rowStyles: {
        padding: '30px 15px 5px 0px',
        display: "flex",
        flexDirection: "column",
        // justifyContent: "flex-end",
        alignItems: "center"
    },
    rowOffset: {
        marginRight: '50%'
    },
    socials: {
        display: 'flex',
        marginBottom: '10px',
    },
    socialInputStyles: {
        width: '100%',
    },
    socialIconStyles: {
        color: 'rgb(0 0 0 / 68%)',
    },
    socialAccountAddButtonStyles: {
        border: '1px solid #76A9FF',
        boxSizing: 'border-box',
        borderRadius: '2px',
        background: 'transparent',
        width: '97%',
        padding: '7px 0px',
    },
    socialMinusButtonStyles: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '10%',
        cursor: 'pointer',
    },
    vw_100: {
        width: '100vw',
    },
    span: {
        display: 'block'
    },
    btnUploaded: {
        backgroundColor: 'rgb(100 38 187)',
        textDecoration: 'none',
        color: 'white',
        cursor: 'pointer',
        padding: '10px 18.5px',
        // marginTop: '15px',
        textAlign: 'center',
        width: "200px",
        borderRadius: "5px"
    },
}